import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import InsurancePlansHero from './components/CareLevelsHero';
import ComparisonTable from './components/ComparisonTable';
import InsurancePlanDetails from './components/CareLevelDetails';

export default function InsurancePlans() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <InsurancePlansHero />
      <ComparisonTable />
      <InsurancePlanDetails />
      <Footer />
    </div>
  );
}
